import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { configureAxios } from "./utils/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import {
  COACH_DASHBOARD_PATH,
  COACH_LEADERBOARD_PATH,
  COACH_EXERCISES_PATH,
  COACH_QUESTIONS_PATH,
  ADMIN_DASHBOARD_PATH,
} from "./routes/navigation/navigation_paths"; // Import necessary path constants

//import css
import "./App.css"; // Import your main CSS file
import "./index.css"; // Import Tailwind CSS

// Components public
import Login from "./Pages/Login";
import Register from "./components/register/Register";
import Activate from "./Pages/Authentication/Activate/Activate";
import ResetPasswordConfirm from "./Pages/Authentication/ResetPasswordConfirm/ResetPasswordConfirm";
import ResetPassword from "./Pages/Authentication/ResetPassword/ResetPassword";


// Components dashboard user
import Score from "./Pages/Score";
import Leaderboard from "./Pages/Leaderboard";
import Pratique from "./components/pratique/Pratique";

// Components pratique user
import PratiqueLayout from "./Pages/PratiqueLayout";
import PratiqueNiveauPage from "./components/pratique/PratiqueNiveau";
import EditeurPratique from "./components/pratique/Editeur";

// Components quiz user
import Quizz from "./Pages/Quizz";
import QuizList from "./Pages/QuizList";
import DifficultySelector from "./Pages/quiz/DifficultySelector";
import QuizPlay from "./Pages/quiz/QuizzPlay";
import QuizReview from "./Pages/quiz/QuizReview";

// Components coach-Dashboard

// Components Admin-Dashboard
import AdminDashboard from "./Pages/AdminDashboard";

import Dashboard from "./Pages/Dashboard";
import ChallengeList from "./Pages/ChallengeList";
import ChallengePlay from "./Pages/ChallengePlay";
import TutorialList from "./Pages/TutorialList";
import TutorialView from "./Pages/TutorialView";
import Profile from "./Pages/Profile";
import Unauthorized from "./Pages/Unauthorized";
import NotFound from "./Pages/NotFound";
import Accueil from "./Pages/Accueil";
// import Evaluation from "./Pages/Evaluation";
import CoachDashboard from "./Pages/CoachDashboard";
import CoachParcours from "./Pages/CoachParcours";
import DashboardUtilisateur from "./components/dashboard_user/Dashboard";
// components coach/Admin dashboard
import DashboardOverviewView from "./Pages/coach/DashboardOverviewView";
import QuizzesView from "./Pages/coach/QuizzesView";
import UtilisateursView from "./Pages/coach/UtilisateursView";
import Evaluations from "./Pages/coach/Evaluation";
import TestDeNiveau from "./Pages/coach/TestDeNiveau";
import CoachLeaderboard from "./Pages/coach/Leaderboard";
// import Test_de_niveau from "";
import DomainesView from "./Pages/coach/DomainesView";
import TechnologiesView from "./Pages/coach/TechnologiesView";
import NiveauxView from "./Pages/coach/NiveauxView";
import CategoriesView from "./Pages/coach/CategoriesView";
import ExercisesView from "./Pages/coach/ExercisesView";
import StatutUsers from "./Pages/coach/StatutUsers";
import QuestionsView from "./Pages/coach/QuestionsView";
import ParcoursView from "./Pages/coach/ParcoursView";
import EvaluationLayout from "./Pages/EvaluationLayout";
import EvaluationChoix from "./components/evaluation/EvaluationChoix";
import EvaluationDetails from "./components/evaluation/EvaluationDetails";
import BakeliCallback from "./Pages/Authentication/Sso/BakeliCallback";
// import PratiquePage from "./Pages/PratiqueNiveauPage";
// import PratiqueNiveauPage from "./components/pratique/PratiqueNiveauPage";

function App() {
  useEffect(() => {
    // Configure axios defaults and interceptors
    configureAxios();
  }, []);
  console.log("DEFAULT_ROUTE:", process.env.REACT_APP_DEFAULT_ROUTE);

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Accueil />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<BakeliCallback />} />
        <Route path="/register" element={<Register />} />
        <Route path="/activate/:uid/:token" element={<Activate />} />
        {/* Reset Password */}
        <Route path="/reset_password" element={<ResetPassword />} />
        <Route path="/password/reset/confirm/:uid/:token" element={<ResetPasswordConfirm />} />
        {/**************** */}
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/accueil" element={<DashboardUtilisateur />} />
        <Route path="/quizz" element={<Quizz />} />
        <Route path="/quizz/review/:quizId" element={<QuizReview />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/pratique" element={<Pratique />} />
        <Route
          path="/pratique"
          element={
            <ProtectedRoute>
              <PratiqueLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Pratique />} />
          <Route path=":languageId" element={<PratiqueNiveauPage />} />
          <Route
            path=":languageId/:levelId/:challengeProfileId"
            element={<EditeurPratique />}
          />
        </Route>
        {/* <Route path="/Evaluation" element={<Evaluation />} /> */}
        <Route
          path="/evaluation"
          element={
            <ProtectedRoute>
              <EvaluationLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<EvaluationChoix />} />
          <Route path=":langage" element={<EvaluationDetails />} />
          <Route path=":langage/pratique/:languageId/:levelId/:challengeProfileId" element={<EditeurPratique />} />
        </Route>

        <Route path="/score" element={<Score />} />
        {/* Corrected CoachDashboard path and wrapped with ProtectedRoute */}
        <Route
          path={COACH_DASHBOARD_PATH}
          element={
            <ProtectedRoute requireCoach={true}>
              <CoachDashboard />
            </ProtectedRoute>
          }
        >
          {/* Define nested routes for CoachDashboard */}
          <Route index element={<DashboardOverviewView />} />{" "}
          {/* Default route for /coach/dashboard */}
          <Route path="quizzes" element={<QuizzesView />} />{" "}
          {/* Route for /coach/dashboard/quizzes */}
          {/* Add other nested coach routes here as they are extracted */}
          <Route
            path="bakelistes"
            element={<UtilisateursView currentUserIsAdmin={false} />}
          />{" "}
          {/* Route for /coach/dashboard/bakelistes */}
          <Route path="test-niveau" element={<TestDeNiveau />} />
          <Route path="leaderboard" element={<CoachLeaderboard />} />
          <Route path="exercices-generes" element={<ExercisesView />} />
          <Route path="domaines" element={<DomainesView />} />{" "}
          <Route path="Evaluations" element={<Evaluations />} />{" "}
          {/* Route for /coach/dashboard/domaines */}
          <Route path="technologies" element={<TechnologiesView />} />{" "}
          {/* Route for /coach/dashboard/technologies */}
          <Route path="niveaux" element={<NiveauxView />} />{" "}
          {/* Route for /coach/dashboard/niveaux */}
          <Route path="categories" element={<CategoriesView />} />
          <Route path="exercises" element={<ExercisesView />} />{" "}
          {/* Route for /coach/dashboard/exercises */}
          {/* <Route path="questions" element={<QuestionsView />} />{" "} */}
          <Route path="utilisateurs" element={<StatutUsers />} />{" "}
          {/* Route for /coach/dashboard/questions */}
          {/* Remove quizzes-m route */}
          {/* <Route path="quizzes-m" element={<div>Quizzes Management Content</div>} /> */}
        </Route>
        <Route path="/coach-parcours" element={<CoachParcours />} />{" "}
        {/* This might need to be a nested route too */}
        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quizzes"
          element={
            <ProtectedRoute>
              <QuizList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quizz/:techId"
          element={
            <ProtectedRoute>
              <DifficultySelector />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quizz/play"
          element={
            <ProtectedRoute>
              <QuizPlay />
            </ProtectedRoute>
          }
        />
        {/* <Route
        path="/quizz/review"
        element={
          // <ProtectedRoute>
          <QuizReview />
          // </ProtectedRoute>
        }
      /> */}
        <Route
          path="/challenges"
          element={
            <ProtectedRoute>
              <ChallengeList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/challenge/:id"
          element={
            <ProtectedRoute>
              <ChallengePlay />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tutorials"
          element={
            <ProtectedRoute>
              <TutorialList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tutorial/:id"
          element={
            <ProtectedRoute>
              <TutorialView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        {/* Admin routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        {/* Corrected CoachDashboard path and wrapped with ProtectedRoute */}
        <Route
          path={ADMIN_DASHBOARD_PATH}
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          }
        >
          {/* Define nested routes for CoachDashboard */}
          <Route index element={<DashboardOverviewView />} />{" "}
          {/* Default route for /coach/dashboard */}
          <Route path="quizzes" element={<QuizzesView />} />{" "}
          {/* Route for /coach/dashboard/quizzes */}
          {/* Add other nested coach routes here as they are extracted */}
          <Route
            path="Utilisateurs"
            element={<UtilisateursView currentUserIsAdmin={true} />}
          />{" "}
          {/* Route for /coach/dashboard/bakelistes */}
          <Route
            path="test-niveau"
            element={<div>Test de niveau Content</div>}
          />
          {/* <Route
            path="exercices-generes"
            element={<div>Exercices générés Content</div>}
          /> */}
          <Route path="domaines" element={<DomainesView />} />{" "}
          {/* Route for /coach/dashboard/domaines */}
          <Route path="technologies" element={<TechnologiesView />} />{" "}
          {/* Route for /coach/dashboard/technologies */}
          <Route path="niveaux" element={<NiveauxView />} />{" "}
          {/* Route for /coach/dashboard/niveaux */}
          <Route path="categories" element={<CategoriesView />} /> Route for
          /coach/dashboard/categories
          <Route path="exercises" element={<ExercisesView />} />{" "}
          {/* Route for /coach/dashboard/exercises */}
          <Route path="questions" element={<QuestionsView />} />{" "}
          <Route path="parcours" element={<ParcoursView />} />{" "}
          {/* Route for /coach/dashboard/questions */}
          {/* Remove quizzes-m route */}
          {/* <Route path="quizzes-m" element={<div>Quizzes Management Content</div>} /> */}
        </Route>
        {/* Top-level Coach Management Routes (if they are not children of CoachDashboard) */}
        {/* 
         <Route path={COACH_LEADERBOARD_PATH} element={<ProtectedRoute requireCoach={true}><CoachLeaderboard /></ProtectedRoute>} />
         <Route path={COACH_EXERCISES_PATH} element={<ProtectedRoute requireCoach={true}><ExercisesView /></ProtectedRoute>} /> 
         <Route path={COACH_QUESTIONS_PATH} element={<ProtectedRoute requireCoach={true}><QuestionsView /></ProtectedRoute>} />
         */}
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
}

export default App;
